import { createSlice } from '@reduxjs/toolkit'
import { DISPLAY_MODES, MODES } from '../../../app/classes/constants';

const setItem = (key, value) => {

    try {
        localStorage.setItem(key, JSON.stringify(value));   
    } catch (error) {
        console.error(error);
    }    
}


const getItem = (key, defaultValue) => {
        

    try {

        if(localStorage.getItem(key) === null){
            return defaultValue;
        }
        else {
            return JSON.parse(localStorage.getItem(key));        
        }        
    } catch (error) {
        console.error(error);
        return defaultValue;
    }
}

// https://redux-toolkit.js.org/tutorials/quick-start

const initialState = {
    wpm: getItem('wpm', 20),
    farnsworthWpm: getItem('farnsworthWpm', 5),
    display: getItem('display', DISPLAY_MODES.LINGERING.id) ,
    type: getItem('type', MODES.TOP_WORDS.id),
    textToSend: '',
    textToDisplay: '',
    isDrawerOpened : getItem('isDrawerOpened',true),
    isAboutOpened : false,
    isPlaying: false,
    useLetters: getItem('useLetters', true),
    useNumbers: getItem('useNumbers', true),
    useSymbols: getItem('useSymbols', true),
    totalCharRepeats: getItem('totalCharRepeats', 3)
}

export const settingsSlice = createSlice({
    name: 'settings',
    initialState,
    reducers: {
        setWpm: (state, action) => {
            state.wpm = action.payload;
            setItem('wpm', action.payload);
            if(window.cwPlayer != null) window.cwPlayer.setWpm(state.wpm);
        },
        setFarnsworthWpm: (state, action) => {
            state.farnsworthWpm = action.payload;         
            setItem('farnsworthWpm', action.payload);   
            if(window.cwPlayer != null) window.cwPlayer.setFarnsworthWpm(state.farnsworthWpm);
        },
        setDisplay: (state, action) => {
            state.display = action.payload;
            setItem('display', action.payload);
            if(window.cwPlayer != null) window.cwPlayer.setDisplayMode(state.display);
        },
        setType: (state, action) => {
            state.type = action.payload;    
            setItem('type', action.payload);    
        },
        setTextToSend: (state, action) => {
            state.textToSend = action.payload;
        },
        setTextToDisplay: (state, action) => {
            state.textToDisplay = action.payload;
        },
        toggleDrawer : (state) => {
            state.isDrawerOpened = !state.isDrawerOpened;
            setItem('isDrawerOpened', state.isDrawerOpened);
        },
        togglePlaying : (state) => {
            state.isPlaying = !state.isPlaying;
        },
        toggleAbout : (state) => {
            state.isAboutOpened = !state.isAboutOpened;
        },
        setUseLetters: (state, action) => { 
            state.useLetters = action.payload;
            setItem('useLetters', action.payload);
            if(window.cwPlayer != null) window.cwPlayer.setUseLetters(state.useLetters);
        },
        setUseNumbers: (state, action) => { 
            state.useNumbers = action.payload;
            setItem('useNumbers', action.payload);
            if(window.cwPlayer != null) window.cwPlayer.setUseNumbers(state.useNumbers);
        },
        setUseSymbols: (state, action) => { 
            state.useSymbols = action.payload;
            setItem('useSymbols', action.payload);
            if(window.cwPlayer != null) window.cwPlayer.setUseSymbols(state.useSymbols);
        },
        setTotalCharRepeats: (state, action) => { 
            state.totalCharRepeats = action.payload;
            setItem('totalCharRepeats', action.payload);
            if(window.cwPlayer != null) window.cwPlayer.setTotalCharRepeats(state.totalCharRepeats);
        },

    },
})

export const {
    setWpm,
    setFarnsworthWpm,
    setDisplay,
    setType,
    setTextToSend,
    toggleDrawer,
    togglePlaying,
    setTextToDisplay,
    setUseLetters,
    setUseNumbers,
    setUseSymbols,
    setTotalCharRepeats,
    toggleAbout
} = settingsSlice.actions

export default settingsSlice.reducer